import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/kiosk-retail2.png";
import IGKiosk from "../../../assets/img/Featured/kiosk-checkout.png";
import IGPanOpticKiosk from "../../../assets/img/Featured/kiosk-panoptic.png";
import Eatec from "../../../assets/img/Featured/tablet-eatec.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";
const GiftShopPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page giftShopPage">
            <Header />
            <div className="page-header">Healthcare Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Gift Shop</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Ensure that the perfect flowers, snacks, or keepsakes 
                    are in stock at the right price for every visitor or patient.{'\n\n'}

                    With InfoGenesis POS, you’ll have the items your staff 
                    and visitors want, and they can seamlessly pay using 
                    their patient account, employee badge, credit card, gift 
                    card, or cash.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Gift Shop", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Gift Shop", "IG Kiosk");
                    addFlow("IG Kiosk");
                    navigate("/solutions/ig-kiosk")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Kiosk
                    </div>
                    <img src={IGKiosk} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Gift Shop", "IG PanOptic Kiosk");
                    addFlow("IG PanOptic Kiosk");
                    navigate("/solutions/ig-panoptic")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG PanOptic Kiosk
                    </div>
                    <img src={IGPanOpticKiosk} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Gift Shop", "Eatec");
                    addFlow("Eatec");
                    navigate("/solutions/eatec")}}>
                    <div className="item-head">
                        <LogoMini />
                        Eatec
                    </div>
                    <img src={Eatec} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default GiftShopPage;